import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Checkbox,
  makeStyles,
  Typography,
  Paper,
  useTheme,
  Grid,
  Chip,
  Avatar,
  IconButton,
  Tooltip,
} from "@material-ui/core";
import SendFill from "../../../Assets/CustomIcons/SendFill";
import { withRouter } from "react-router-dom";
import axios from "axios";
import Spinner from "../../../UI/Spinner/Spinner";
import ArrowForwardIosRoundedIcon from "@material-ui/icons/ArrowBackIosRounded";
import ConfigurationListsContext from "../../../context/configurationListsContext";
import { getInitials } from "../../../config/candidatesConfigData";
import { exceedsLimit } from "prettier";

const DRAWER_WIDTH = 240;
const useStyles = makeStyles((theme) => ({
  root: {},
  footer: {
    position: "fixed",
    right: 0,
    bottom: 0,
    width: `calc(100% - ${DRAWER_WIDTH}px)`,
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(2),
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4),
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  framedValue: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    border: "1px solid #A4A6B3",
    borderRadius: theme.spacing(2),
    minWidth: "250px",
    marginRight: theme.spacing(2),
  },
  paper: {
    boxShadow:
      "0px 6px 116px rgba(164, 166, 179, 0.21), 0px 1.80882px 34.9706px rgba(164, 166, 179, 0.136834), 0px 0.751293px 14.525px rgba(164, 166, 179, 0.105), 0px 0.271728px 5.25341px rgba(164, 166, 179, 0.0731663)",
    borderRadius: theme.spacing(2),
    padding: theme.spacing(2),
    "& .MuiChip-root": {
      marginRight: theme.spacing(2),
      marginBottom: theme.spacing(2),
    },
    minHeight: "250px",
    "& .MuiAvatar-root": {
      width: theme.spacing(5),
      height: theme.spacing(5),
      marginRight: theme.spacing(1),
    },
  },
  borderHighlight: {
    border: `1px solid ${theme.palette.primary.main}`,
  },
}));

const SignalPreview = (props) => {
  const [signalCompanies, setSignalCompanies] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [potentialCandidatesCount, setPotentialCandidatesCount] = useState(0);
  const [error, setError] = useState(null);
  const classes = useStyles();

  useEffect(() => {
    const getData = async () => {
      setIsLoading(true);
      try {
        const data = await axios.post("/wp-json/api/v2/signal_notifications", {
          preview: true,
        });
        setPotentialCandidatesCount(data.data.candidates.length);
        let localSignalCompanies = [];
        Object.keys(data.data.companies_data).map((comp) => {
          localSignalCompanies = [
            ...localSignalCompanies,
            {
              id: parseInt(comp),
              value: data.data.companies_data[comp],
              selected: true,
            },
          ];
        });
        setSignalCompanies(localSignalCompanies);
        setIsLoading(false);
      } catch (err) {
        setError(err.response);
        setIsLoading(false);
      }
    };
    getData();
  }, []);

  const handleOnSelect = (id, checked) => {
    const localCompanies = [...signalCompanies];
    const compIndex = localCompanies.findIndex((ind) => ind.id === id);
    if (compIndex > -1) {
      localCompanies[compIndex].selected = checked;
    }
    setSignalCompanies(localCompanies);
  };

  const handleDistributeSingals = async () => {
    const excludeCompanies = signalCompanies.filter(
      (comp) => comp.selected === false
    );
    try {
      axios.post("/wp-json/api/v2/signal_notifications", {
        exclude_companies: excludeCompanies.map((comp) => comp.id),
      });
      props.history.push("/companies/signal-manager");
    } catch (err) {
      setError(err.response);
    }
  };

  const countCategories = () => {
    let catCount = [];
    signalCompanies.forEach((comp) =>
      comp.value.cat.map((cat) => {
        if (!catCount.includes(parseInt(cat)))
          catCount = [...catCount, parseInt(cat)];
      })
    );
    return catCount.length;
  };

  return (
    <React.Fragment>
      <Box p={2} mt={0}>
        <Tooltip title="Back to companies">
          <IconButton
            aria-label="back"
            onClick={() => props.history.push("/companies")}
          >
            <ArrowForwardIosRoundedIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      </Box>
      {isLoading && <Spinner open={isLoading} />}
      <Box p={2} mt={2}>
        <Typography variant="h5">Signal Preview</Typography>
        <Typography variant="body1">
          The following companies will recieve a signal notification. Uncheck
          companies you wish to exclude:
        </Typography>
      </Box>
      <Box p={2} mt={2} mb={10}>
        <Grid container spacing={2}>
          {signalCompanies.length > 0 &&
            signalCompanies.map((comp) => (
              <SignalCompanyItem
                company={comp}
                key={comp.id}
                onSelect={handleOnSelect}
              />
            ))}
        </Grid>
      </Box>
      <Box className={classes.footer}>
        <Box display={"flex"} justifyContent="flex-start" alignItems={"center"}>
          <StyledFramedValue
            caption={"Selected Companies"}
            value={signalCompanies.filter((comp) => comp.selected).length}
          />
          <StyledFramedValue
            caption={"Detected Categories"}
            value={countCategories()}
          />
          <StyledFramedValue
            caption={"Potential Candidates"}
            value={potentialCandidatesCount}
          />
        </Box>
        <Button
          variant="contained"
          color="primary"
          endIcon={<SendFill />}
          onClick={handleDistributeSingals}
        >
          Distribute Now
        </Button>
      </Box>
    </React.Fragment>
  );
};
export default withRouter(SignalPreview);

const StyledFramedValue = ({ value, caption }) => {
  const classes = useStyles();
  return (
    <Box
      display={"flex"}
      justifyContent="space-between"
      alignItems={"center"}
      className={classes.framedValue}
    >
      <Typography variant="smallText">{caption}</Typography>
      <Typography variant="body1">
        <strong>{value}</strong>
      </Typography>
    </Box>
  );
};

const SignalCompanyItem = ({ company, onSelect }) => {
  const classes = useStyles();
  const theme = useTheme();
  return (
    <Grid item xs={3}>
      <Paper
        className={`${classes.paper} ${
          company.selected ? classes.borderHighlight : ""
        }`}
      >
        <Box
          display={"flex"}
          justifyContent="space-between"
          alignItems={"center"}
        >
          <Box display={"flex"} alignItems="center">
            <Avatar variant="rounded" className={classes.smallAvatar}>
              {getInitials(company.value.company_name)}
            </Avatar>
            <Typography variant="subtitle1">
              {company.value.company_name}
            </Typography>
          </Box>
          <Checkbox
            color="primary"
            checked={company.selected}
            onClick={(event) => onSelect(company.id, event.target.checked)}
          />
        </Box>
        <Box
          display={"flex"}
          justifyContent="flex-start"
          alignItems={"center"}
          flexWrap={"wrap"}
          my={theme.spacing(2)}
        >
          <ConfigurationListsContext.Consumer>
            {(context) =>
              company &&
              company.value.cat.map((cat) => (
                <Chip
                  label={
                    context.professionsList.find(
                      (prof) => prof.id === parseInt(cat)
                    ).name
                  }
                  key={cat}
                />
              ))
            }
          </ConfigurationListsContext.Consumer>
        </Box>
      </Paper>
    </Grid>
  );
};
